<template>
  <div>
    <h1 class="mb-8">Account</h1>

    <div class="flex flex-wrap">
      <div class="w-full md:w-1/2">
        <h3>Change your password</h3>
        <br>

        <form @submit.prevent="submit">
          <div class="mb-4">
            <label class="block text-[13px] font-medium text-ink mb-1.5">Enter original password:</label>
            <input id="password"
                          type="password"
                          class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"
                          v-model="password.old_password"
                          required>
          </div>
          <div class="mb-4">
            <label class="block text-[13px] font-medium text-ink mb-1.5">New password:</label>
            <input id="password-new"
                          type="password"
                          class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"
                          v-model="password.password"
                          required>
          </div>
          <div class="mb-4">
            <label class="block text-[13px] font-medium text-ink mb-1.5">Re-enter new password:</label>
            <input id="password-repeat"
                          type="password"
                          class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"
                          v-model="passwordConfirmation"
                          required>
          </div>
          <div class="error" v-if="hasError">
            {{ this.errorInfo }}
          </div>
          <p v-if="password.password && !passwordsMatch"><span class="text-[#e53935] text-sm">The password confirmation does not match.</span></p>
          <p v-if="submitted"><span class="text-[#2d7a0e] text-sm">Password changed.</span></p>
          <button type="submit" class="rounded-3xl bg-primary border-none px-[30px] py-3 text-white tracking-[0.03em] hover:opacity-85 transition-opacity cursor-pointer">Change password</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      password: {
        old_password: null,
        password: null
      },
      submitted: false,
      hasError: false,
      errorInfo: null,
      passwordConfirmation: null,
      passwordsMatch: false
    }
  },
  computed: {
  },
  methods: {
    submit () {
      const { password } = this
      this.$store.dispatch('UPDATE_PASSWORD', { password }).then((response) => {
        // TODO: feedback
        this.submitted = true
        this.resetForm()
      }, error => {
        console.error('Password update failed:', error)
      })
    },
    resetForm () {
      this.password.old_password = null
      this.password.password = null
    }
  },
  watch: {
    'passwordConfirmation' () {
      if (this.password.password === this.passwordConfirmation) {
        this.passwordsMatch = true
      } else {
        this.passwordsMatch = false
      }
    }
  }
}
</script>